import { AppealsDetail } from 'feature/appeals/view'
import { MainLayout } from 'layouts'

type TAppealsDetail = {
  type: 'order' | 'lead'
}

export function AppealsDetailPage({ type }: TAppealsDetail) {
  return (
    <MainLayout>
      <div className='container'>
        <AppealsDetail type={type} />
      </div>
    </MainLayout>
  )
}
